var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKundenlogoRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 61,
    viewBox: "0 0 122 61",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#335466",
    x: 0.5,
    y: 0.5,
    width: 121,
    height: 60,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M78.08 22.773h28.467V39.04H78.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F5",
    d: "M86.927 26.512h1.976v7.057H97.7V35.3H86.927z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#455A64",
    d: "M47.173 22.773H75.64V39.04H47.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F5F5",
    d: "M60.417 28.245h-5.003v-1.733h11.984v1.733h-5.003V35.3h-1.978z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#335466",
    d: "M15.453 22.773H43.92V39.04H15.453z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.539 26.512h7.586c2.31 0 3.595 1.055 3.595 2.824 0 1.519-.964 2.537-2.607 2.776l3.72 3.19h-2.855l-3.496-3.078h-3.965v3.075h-1.976v-8.787h-.002zm7.327 4.067c1.223 0 1.815-.402 1.815-1.218s-.592-1.206-1.815-1.206h-5.349v2.422h5.349v.002z",
    fill: "#F4F5F5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoRtl);
export default __webpack_public_path__ + "static/media/kundenlogo-rtl.8e0825b2786c19e338eb797ec6699b6f.svg";
export { ForwardRef as ReactComponent };